module.exports = __webpack_public_path__ + "static/img/荣誉_09@2x.80aa0992.png";